let PressureCalibration_instance = null;
class PointF {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
}
export class PressureCalibration {
    constructor() {
        /* #endregion */
        /* #region  Calculate Calibration Factor  */
        this.MAX_FACTOR = 1023;
        this.MAX_CURVE = 2000;
        /* #endregion */
    }
    /* #region  사용되는 함수 */
    static get Instance() {
        if (!PressureCalibration_instance) {
            PressureCalibration_instance = new PressureCalibration();
        }
        return PressureCalibration_instance;
    }
    static SetPressureCalibrateFactor(cPX1, cPY1, cPX2, cPY2, cPX3, cPY3) {
        PressureCalibration.Instance.MakeFactor(cPX1, cPY1, cPX2, cPY2, cPX3, cPY3);
    }
    static GetPressureCalibrationFactor(index) {
        if (index < 0 || index > PressureCalibration.Instance.MAX_FACTOR)
            return -1;
        return PressureCalibration.Instance.Factor[index];
    }
    get Factor() {
        return this.pressureCalibrationFactor;
    }
    Clear() {
        this.pressureCalibrationFactor = null;
    }
    MakeFactor(cPX1, cPY1, cPX2, cPY2, cPX3, cPY3) {
        this.pressureCalibrationFactor = new Float64Array(this.MAX_FACTOR + 1);
        const pCurve = Array.from({ length: this.MAX_CURVE }, (_, i) => new PointF(0, 0));
        const point = [
            new PointF(cPX1, cPY1),
            new PointF(cPX2, cPY2),
            new PointF(cPX2, cPY2),
            new PointF(cPX3, cPY3),
        ];
        this.ComputeBezier(point, this.MAX_CURVE, pCurve);
        let count = 0;
        let prevCount = 0;
        const length = pCurve.length - 1;
        for (let i = 0; i < length; i++) {
            if (count < pCurve[i].x) {
                if (Math.abs(pCurve[prevCount].x - count) > Math.abs(pCurve[i].x - count))
                    this.pressureCalibrationFactor[count] = pCurve[i].y;
                else
                    this.pressureCalibrationFactor[count] = pCurve[prevCount].y;
                if (this.pressureCalibrationFactor[count] > this.MAX_FACTOR)
                    this.pressureCalibrationFactor[count] = this.MAX_FACTOR;
                count++;
                if (count > this.MAX_FACTOR)
                    count = this.MAX_FACTOR;
            }
            else {
                prevCount = count;
            }
        }
        this.pressureCalibrationFactor[this.MAX_FACTOR] = pCurve[this.MAX_CURVE - 1].y;
        if (this.pressureCalibrationFactor[this.MAX_FACTOR] > this.MAX_FACTOR)
            this.pressureCalibrationFactor[this.MAX_FACTOR] = this.MAX_FACTOR;
        // #if DEBUG_LOG
        // for (int i = 0; i < mModifyPressureFactor.Length; i++)
        // {
        //   System.Diagnostics.Debug.WriteLine("test mPressureFactor" + i + ":" + mModifyPressureFactor[i]);
        // }
        // #endif
    }
    GetPressureCalibrateFactor(cPX1, cPY1, cPX2, cPY2, cPX3, cPY3) {
        this.MakeFactor(cPX1, cPY1, cPX2, cPY2, cPX3, cPY3);
        return this.pressureCalibrationFactor;
    }
    ComputeBezier(cp, numberOfPoints, curve) {
        const dt = 1.0 / (numberOfPoints - 1);
        for (let i = 0; i < numberOfPoints; i++)
            curve[i] = this.PointOnCubicBezier(cp, i * dt);
    }
    PointOnCubicBezier(cp, t) {
        const cx = 3.0 * (cp[1].x - cp[0].x);
        const bx = 3.0 * (cp[2].x - cp[1].x) - cx;
        const ax = cp[3].x - cp[0].x - cx - bx;
        const cy = 3.0 * (cp[1].y - cp[0].y);
        const by = 3.0 * (cp[2].y - cp[1].y) - cy;
        const ay = cp[3].y - cp[0].y - cy - by;
        const tSquared = t * t;
        const tCubed = tSquared * t;
        const x = (ax * tCubed) + (bx * tSquared) + (cx * t) + cp[0].x;
        const y = (ay * tCubed) + (by * tSquared) + (cy * t) + cp[0].y;
        return new PointF(x, y);
    }
}
//# sourceMappingURL=PressureCalibration.js.map